import { globalJS } from "./global";
import lozad from "lozad";
import { headerFunction } from "./header";
import {
	clickToSection,
	convertImgToSvg,
	countDecimals,
	debounce,
	isTouchDevice,
	loading,
	onLoadToSection,
	stickElementToEdge,
} from "./ultil";
import { fancyboxSetting, preventPopup } from "./fancyboxSetting";
import { CountUp } from "countup.js";
import { homePage } from "./homePage";
import { animateComponent } from "./animateComponent";
import { toast } from "./notification";
import { swiperInit } from "./SwiperInit";
import chart, {
	formatDate,
	formatNumber,
	getTopValue,
	formatMonth,
	tableToolTip,
	chartLineStyles,
} from "./chart";

$.fn.hasAttr = function (name) {
	return this.attr(name) !== undefined;
};
// ******* Global Variable s*******

// *** Window
export const ww = $(window).width();
// *** Header *** //
export const header = $("header");
export const mainSection = $("main");
export const height_header = header.outerHeight();
export const burger = header.find("#burger");
export const overlay = $("#overlay");
export const body = $("body");
// *** Nav Mobile *** //
export const nav_mobile = $(".nav-mobile");
export const isTouchScreenOrMobile = ww < 1200 || isTouchDevice();

export let scriptPath = `../scripts`;
if (
	typeof window.lz !== "undefined" &&
	typeof window.lz === "object" &&
	typeof window.lz.updateScriptPath !== "undefined"
) {
	scriptPath = window.lz.updateScriptPath;
}

const FE = {
	lozadInit,
	generateSVG,
	closeFancybox: fancyboxSetting.closeFancybox,
	triggerFancybox: fancyboxSetting.triggerFancybox,
	initFancybox: fancyboxSetting.init,
	debounce: debounce,
	customTab,
	headerFunction,
	loading,
	toggleFaqsAskModule,
	toast,
	formatNumber,
	getTopValue,
	formatDate,
	formatMonth,
	chart,
	detectSticky,
	preventPopup,
	createTableTooltip: tableToolTip.createTooltip,
	chartLineStyles,
	customTablePagination,
};

function activeCommonNav() {
	if ($(".primary-nav ul").length) {
		$(".primary-nav ul").scrollTo("li.active", 300);
	}
	if ($(".secondary-nav ul").length) {
		$(".secondary-nav ul").scrollTo("li.active", 300);
	}
	if ($(".nav-wrapper").length) {
		$(".nav-wrapper").scrollTo("li.active", 300);
	}
	if ($(".secondary-nav ul").length) {
		$(".secondary-nav ul").scrollTo("li.active", 300);
	}
}

const lazyLoader = lozad(".lozad", {
	rootMargin: "10px 0px", // syntax similar to that of CSS Margin
	threshold: 0.2, // ratio of element convergence
	enableAutoReload: true, // it will reload the new image when validating attributes changes
	loaded: function (el) {
		globalJS.autoFillNoImage(el);
	},
});

export function lozadInit() {
	lazyLoader.observe();
	window.lazyLoader = lazyLoader;
}

export function generateSVG(selector = ".image-svg") {
	var imageContainers = document.querySelectorAll(selector);
	imageContainers.forEach(function (imageContainer) {
		// Find the img element within each container
		var images = imageContainer.querySelectorAll("img");
		images.forEach((img) => {
			convertImgToSvg(img);
		});
	});
}

function toggleFaqsAskModule() {
	$(".module-toggle").each(function () {
		const $this = $(this);
		let willOpenAll = $this.attr("data-open-all") || "false";
		let openFirstItem = $this.attr("data-open-first-item") || "false";
		let openAtleastOne = $this.attr("data-open-atleast-one") || "false";
		let showAll = $this.attr("data-show-all") || "false";
		let split = $this.attr("data-split") || 1;
		if (openFirstItem === "" || openFirstItem === "true") {
			$this
				.find(".item")
				.first()
				.addClass("active")
				.find(".bottom")
				.slideDown();
			$this.find(".item-trigger").first().addClass("active");
		}

		if (showAll === "true") {
			$this.find(".item").addClass("active").find(".bottom").show();
			$this.find(".item-trigger").addClass("active");
		}

		if (split > 1) {
			$this.addClass(`module-split-${split}`);
			let $items = $this.find(".item");
			let countItems = $items.length;
			let countItemsPerColumn = Math.ceil(countItems / split);
			for (let i = 0; i < split; i++) {
				const $column = $(
					`<div class="split-column split-column-${i}"></div>`
				);
				$this.append($column);
			}
			$items.each(function (index, item) {
				const cloneItem = $(item).clone();
				item.remove();
				cloneItem.addClass(`split-item-${index}`);
				cloneItem.attr("data-index", index);
				// * Push item to columns by item mod number of columns
				// $this.find(`.split-column-${index % split}`).append(cloneItem);
				// let columnIndex = index % split;
				// * Push item to columns by item order
				let columnIndex = Math.floor(index / (countItems / split));
				$this.find(`.split-column-${columnIndex}`).append(cloneItem);
			});
		}
		var item = $(this).find(".item .top");
		var itemTrigger = $(this).find(".item-trigger");
		item.on("click", function () {
			if (split > 1) {
				handleClickMultiColumn($(this).parent());
			} else {
				handleClickSingleColumn($(this).parent());
			}
		});
		itemTrigger.on("click", function () {
			if (split > 1) {
				handleClickMultiColumn($(this));
			} else {
				handleClickSingleColumn($(this));
			}
		});
		function handleClickSingleColumn(currentItem) {
			const index = currentItem.index();

			if (willOpenAll === "" || willOpenAll === "true") {
				currentItem.toggleClass("active");
				currentItem.find(".bottom").slideToggle();

				return;
			}
			$this
				.find(".item")
				.not(".item:eq(" + index + ")")
				.find(".bottom")
				.slideUp();
			$this
				.find(".item")
				.not(".item:eq(" + index + ")")
				.removeClass("active");
			$this
				.find(".item-trigger")
				.not(".item-trigger:eq(" + index + ")")
				.removeClass("active");

			if (currentItem.hasClass("active")) {
				if (openAtleastOne === "false") {
					$this.find(".item").removeClass("active");
					$this.find(".item").eq(index).find(".bottom").slideUp();
					$this.find(".item-trigger").removeClass("active");
					$this.find(".item-default").addClass("active");
				}
			} else {
				$this.find(".item").eq(index).addClass("active");
				$this.find(".item").eq(index).find(".bottom").slideDown();
				$this.find(".item-trigger").eq(index).addClass("active");
				$this.find(".item-default").removeClass("active");
			}
		}

		function handleClickMultiColumn(currentItem) {
			const index = currentItem.attr("data-index");
			const parentColumnIndex = currentItem
				.closest(".split-column")
				.index();
			const isActive = currentItem.hasClass("active");
			let otherItems;
			// * Select all other items in all columns
			if (ww > 1024) {
				otherItems = $this
					.find(`.split-column-${parentColumnIndex}`)
					.find(`.item:not(.split-item-${index})`);
			} else {
				otherItems = $this.find(`.item:not(.split-item-${index})`);
			}

			// * Select all other items in the current column

			otherItems.find(".bottom").slideUp();
			otherItems.removeClass("active");

			if (isActive) {
				if (openAtleastOne === "false") {
					currentItem.find(".bottom").slideUp();
					currentItem.removeClass("active");
				}
			} else {
				currentItem.find(".bottom").slideDown();
				currentItem.addClass("active");
			}
		}
	});
}

export function counterUpNumber(separator = "", decimal = ",") {
	const options = {
		separator: separator,
		decimal: decimal,
		enableScrollSpy: true,
		duration: 2.5,
	};
	var counters = document.querySelectorAll(".counter");
	for (let counter of counters) {
		const value = counter.dataset.count;
		if (Number(value) === NaN) return;
		if (!value) return;
		const decimalsLength = countDecimals(value);
		const newOptions = { ...options };
		if (decimalsLength > 0) {
			newOptions.decimalPlaces = decimalsLength;
		}
		var countUp = new CountUp(counter, value, newOptions);
		countUp.start();
	}
}

export function customTab() {
	$("[tab-wrapper]").each(function () {
		const $this = $(this);
		if ($this.data("initialized")) return;
		$this.data("initialized", true);
		$this.addClass("tab-wrapper-initialized");
		const tabValue = $this.attr("tab-wrapper");
		let tabMode = $this.attr("tab-mode") || "click";

		let activeValue =
			$this.find(`[tab-item=${tabValue}].active`).index() === -1
				? $this
						.find(`[tab-item=${tabValue}]`)
						.eq(0)
						.attr(`tab-item-value`)
				: $this
						.find(`[tab-item=${tabValue}].active`)
						.attr(`tab-item-value`);

		$this
			.find(`[tab-item=${tabValue}][tab-item-value='${activeValue}']`)
			.addClass("active");
		$this
			.find(
				`[tab-content=${tabValue}][tab-content-value='${activeValue}']`
			)
			.addClass("active")
			.show();

		$this.find(`[tab-content=${tabValue}]`).each(function () {
			const $currentContent = $(this);
			const tabContentValue = $currentContent.attr("tab-content-value");
			if (tabContentValue.split("|").includes(activeValue)) {
				$currentContent.addClass("active").show();
			}
		});

		$this.find(`[tab-item=${tabValue}]`).on(tabMode, function () {
			const isActive = $(this).hasClass("active");
			if (isActive) return;
			const value = $(this).attr(`tab-item-value`);
			const href = $(this).attr(`href`);
			$(this).addClass("active");
			$this
				.find(`[tab-item=${tabValue}]`)
				.not(this)
				.removeClass("active");
			$this
				.find(`[tab-content=${tabValue}]`)
				.removeClass("active")
				.hide();
			const tabContents = $this.find(`[tab-content=${tabValue}]`);
			tabContents.each(function () {
				const $currentContent = $(this);
				const tabContentValue =
					$currentContent.attr("tab-content-value");
				if (tabContentValue.split("|").includes(value)) {
					$currentContent.addClass("active").fadeIn(300);
				}
			});
			activeCommonNav();
		});
	});
}

export const lenis = {
	setupLenis() {
		// const isSmooth = ww > 1200 ? true : false;
		const isSmooth = false;
		const lenis = new Lenis({
			autoRaf: true,
			prevent: (node) => {
				return node.classList.contains("overflow-auto");
			},
			smoothWheel: isSmooth,
		});
		// Use requestAnimationFrame to continuously update the scroll
		function raf(time) {
			lenis.raf(time);
			requestAnimationFrame(raf);
		}

		requestAnimationFrame(raf);
		window.bodyLenis = lenis;
	},
	stopScroll() {
		window.bodyLenis.stop();
		// document.body.style.overflow = "hidden";
	},
	resumeScroll() {
		window.bodyLenis.start();
		// document.body.style.overflow = "auto";
	},
	init() {
		this.setupLenis();
	},
};

$(document).ready(function () {
	scriptsOnFontLoaded();
	generateSVG();
	lenis.init();
	// ---***--- Global JS ---***---
	globalJS.init();

	// ---***--- Header ---***---
	headerFunction.init();
	// ---***--- Body ---***---
	homePage.init();
	//
	chart.init();

	//
	toggleFaqsAskModule();

	// ---***--- Template Page ---***---

	// ---***--- Fancybox ---***---
	fancyboxSetting.init();

	// ---***--- Other ---***---
	lozadInit();
	counterUpNumber();

	activeCommonNav();
	clickToSection();
	swiperInit();
	customTab();
	animateComponent.init();
	addingPadding();
	detectSticky();
	customTablePagination();
	// FE.triggerFancybox("popup-warning", "popup-warning", {
	// 	closeButton: false,
	// 	escKey: false,
	// 	backdropClick: false,
	// 	keyboard: {
	// 		Backspace: false,
	// 		Delete: false,
	// 		Escape: false,
	// 	},
	// });
});

function detectSticky() {
	// get the sticky element
	const stickyElms = document.querySelectorAll(".table-responsive");

	stickyElms.forEach((elm) => {
		if (elm.classList.contains("table-responsive-initialized")) return;
		elm.classList.add("table-responsive-initialized");
		const thead = elm.querySelector("thead");
		if (!thead) return;

		const sentinel = document.createElement("div");
		sentinel.style.height = "1px";
		sentinel.style.position = "absolute";
		sentinel.style.top = "0";
		sentinel.style.left = "0";
		sentinel.style.width = "100%";
		sentinel.style.pointerEvents = "none";
		sentinel.classList.add("sticky-sentinel");

		const table = elm.querySelector("table");
		if (table) {
			table.parentNode.insertBefore(sentinel, table);
		}

		const observer = new IntersectionObserver(
			([entry]) => {
				// When sentinel is not visible (intersectionRatio < 1),
				// it means we've scrolled past it and thead should be sticky
				const isSticky = entry.intersectionRatio < 1;
				thead.classList.toggle("isSticky", isSticky);
				tableToolTip.init();
			},
			{
				threshold: [0, 1],
				root: elm, // Use the scrollable container as root
			}
		);

		observer.observe(sentinel);
	});
}

function customTablePagination() {
	const tables = $(".table-pagination");
	if (tables.length === 0) return;

	tables.each(function () {
		const $this = $(this);
		// Clean up previous pagination if it exists, allowing re-initialization
		$this.parent().find(".table-custom-pagination").remove();

		const $tbody = $this.find("tbody");
		const allListItems = $tbody.children("tr").detach(); // Detach all rows and store them
		const postsPerPage = parseFloat($this.data("posts-per-page")) || 10;
		const numPages = Math.ceil(allListItems.length / postsPerPage);

		if (numPages <= 1) {
			// If there's only one page or no content, re-append the items and stop.
			$tbody.append(allListItems);
			return;
		}

		let currentPage = 0;

		const pagination = document.createElement("div");
		pagination.classList.add("table-custom-pagination");

		const ul = document.createElement("ul");
		ul.classList.add("ul-pagination");

		const createNavItem = (text, pageIndex, classes = []) => {
			const li = document.createElement("li");
			li.classList.add("page-item", ...classes);
			const a = document.createElement("a");
			a.classList.add("page-link");
			a.innerHTML = text;
			if (pageIndex !== null) {
				$(a).data("page", pageIndex);
			}
			li.appendChild(a);
			return li;
		};

		const updatePaginationItems = () => {
			$(ul).find(".page-normal-link, .page-ellipsis").remove();

			const pageLinks = [];
			const pagesOnEachSide = 1; // How many pages to show on each side of the current page
			const pagesAtEnds = 1; // How many pages to show at the start and end

			// Create page items
			for (let i = 0; i < numPages; i++) {
				const isFirstPage = i < pagesAtEnds;
				const isLastPage = i >= numPages - pagesAtEnds;
				const isNearCurrent =
					i >= currentPage - pagesOnEachSide &&
					i <= currentPage + pagesOnEachSide;

				if (isFirstPage || isLastPage || isNearCurrent) {
					const li = createNavItem(
						i + 1,
						i,
						i === currentPage
							? ["active", "page-normal-link"]
							: ["page-normal-link"]
					);
					pageLinks.push(li);
				}
			}

			// Add ellipsis
			const withEllipsis = [];
			let lastPage = -1;
			pageLinks.forEach((li) => {
				const page = $(li).find("a").data("page");
				if (lastPage !== -1 && page > lastPage + 1) {
					const ellipsis = createNavItem("...", null, [
						"page-ellipsis",
						"disabled",
					]);
					withEllipsis.push(ellipsis);
				}
				withEllipsis.push(li);
				lastPage = page;
			});

			$(ul).find(".prev-page").after(withEllipsis);
		};

		const showPage = (page) => {
			currentPage = page;
			const start = currentPage * postsPerPage;
			const end = start + postsPerPage;

			const pageItems = allListItems.slice(start, end);
			$tbody.empty();
			$tbody.append(pageItems);

			updatePaginationItems();

			updateNavButtons();
		};

		const updateNavButtons = () => {
			$(pagination)
				.find(".prev-page, .go-to-first-page")
				.toggleClass("disabled", currentPage === 0);
			$(pagination)
				.find(".next-page, .go-to-last-page")
				.toggleClass("disabled", currentPage === numPages - 1);
		};

		// Add navigation buttons
		const firstBtn = createNavItem(
			'<i class="fa-solid fa-angles-left"></i>',
			0,
			["go-to-first-page"]
		);
		const prevBtn = createNavItem(
			'<i class="fa-solid fa-angle-left"></i>',
			"prev",
			["prev-page"]
		);
		const nextBtn = createNavItem(
			'<i class="fa-solid fa-angle-right"></i>',
			"next",
			["next-page"]
		);
		const lastBtn = createNavItem(
			'<i class="fa-solid fa-angles-right"></i>',
			numPages - 1,
			["go-to-last-page"]
		);

		ul.prepend(prevBtn);
		ul.prepend(firstBtn);
		ul.append(nextBtn);
		ul.append(lastBtn);

		pagination.append(ul);

		// Initial setup
		showPage(0);
		$this.parent().append(pagination);

		// Add click events
		$(pagination).on("click", "a", function (e) {
			e.preventDefault();
			const $target = $(this);
			if (
				$target.parent().hasClass("disabled") ||
				$target.parent().hasClass("active")
			)
				return;

			let newPage = $target.data("page");

			if (newPage === "prev") {
				newPage = currentPage > 0 ? currentPage - 1 : 0;
			} else if (newPage === "next") {
				newPage =
					currentPage < numPages - 1 ? currentPage + 1 : numPages - 1;
			}

			showPage(newPage);
		});

		updateNavButtons();
	});
}

function addingPadding() {
	if (
		$(".main-banner").length === 0 &&
		$(".page-banner").length === 0 &&
		$(".global-breadcrumb").length === 0 &&
		$(".home").length === 0
	) {
		$("main").prepend(`<div class="padding-header"></div>`);
	}
}

function scriptsOnFontLoaded() {
	document.fonts.ready.then(() => {
		// var t0 = performance.now();
		// var t1 = performance.now();
		// console.log("Call to homepage took " + (t1 - t0) + " milliseconds.");
	});
}

$(window).on("resize", function () {
	stickElementToEdge();
});

$(window).trigger("resize");

// ***** Preload ***** //
document.onreadystatechange = () => {
	if (document.readyState === "complete") {
		/**
		 * Turn on when Deploy
		 */

		//
		//
		//
		//
		// Load to section
		onLoadToSection();
	}
};

window.FE = FE;
